export default __webpack_public_path__ + "static/media/640_dummy2016-friseur01-de.c8395d3f.png";